/** @jsx h */
import { showCount } from '../config';
import { Fragment } from 'preact';
import { useRef, useState } from 'preact/hooks';
import Pagination from './Pagination';
import ResultTitle from './ResultTitle';
import ResultIcon from './ResultIcon';

const TeaserCourses = ({
  allResultCount,
  list,
  pagination,
  loadMore,
  pluginNamespace,
  triggerAjaxSubmit,
  sorting,
}) => {
  const [headColsArray] = useState([
    { label: 'Title', name: 'title' },
    { label: 'Date', name: 'date' },
    { label: 'Open for', name: 'openFor' },
    { label: 'Topic', name: 'topic' },
  ]);
  const sortingInputEl = useRef(null);
  const resultContainerEl = useRef(null);
  const [tableRowOpen, setTableRowOpen] = useState({});

  const toggleOpen = (uid, e) => {
    e.preventDefault();
    setTableRowOpen({
      ...tableRowOpen,
      [uid]: !tableRowOpen[uid],
    });
  };

  function handleSortingClick(e) {
    const button = e.currentTarget;
    const value = button.dataset.value;

    // replace old sorting with new one and submit form
    if (sortingInputEl && sortingInputEl.current) {
      sortingInputEl.current.value = value;
    }
    triggerAjaxSubmit();
  }

  function handleLoadMoreClick() {
    loadMore();
  }

  return (
    <Fragment>
      <header className="search-table__count sr-only">
        <label for="sorting" className="sorting__input">
          <input
            id="sorting"
            name={`${pluginNamespace}[sort]`}
            type="text"
            readonly
            ref={sortingInputEl}
          />
        </label>
      </header>
      <div className="search-section__result-container">
        {allResultCount && showCount && (
          <div className="search-section__result-header">
            <ResultTitle allResultCount={allResultCount} />
          </div>
        )}

        <table className="search-table" ref={resultContainerEl}>
          <thead>
            <tr>
              {headColsArray.map(headCol => {
                // check whenever a headCol should have sorting option or not
                // we compare it with the sorting array in the json to find that out
                const sortingObj = sorting.find(
                  sort => sort.name === headCol.name
                );

                return (
                  // eslint-disable-next-line react/jsx-key
                  <td>
                    {sortingObj ? (
                      <a
                        type="button"
                        role="button"
                        className={`search-table__sort-link is-${sortingObj.sortingDirection}ending`}
                        data-direction={sortingObj.sortingDirection}
                        data-value={`${sortingObj.name} ${sortingObj.sortingDirection}`}
                        onClick={handleSortingClick}
                      >
                        <span>{headCol.label}</span>
                        <span className="search-table__sort-indicator">
                          <svg
                            width="20"
                            height="20"
                            class="svg-caret-down"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 20 20"
                          >
                            <path
                              fill="currentColor"
                              d="M512 685 158 307h708L512 685Z"
                              style="fill-rule:nonzero"
                              transform="matrix(-.02725 0 0 -.02725 23.91 22.888)"
                            />
                          </svg>
                          <svg
                            width="20"
                            height="20"
                            class="svg-caret-up"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 20 20"
                          >
                            <path
                              fill="currentColor"
                              d="M512 685 158 307h708L512 685Z"
                              transform="matrix(.02725 0 0 .02725 -3.868 -2.263)"
                            />
                          </svg>
                        </span>
                      </a>
                    ) : (
                      headCol.label
                    )}
                  </td>
                );
              })}
            </tr>
          </thead>
          <tbody>
            {list &&
              list.map((result, index) => (
                // eslint-disable-next-line react/jsx-key
                <>
                  <tr
                    key={result.uid}
                    className={`search-table__row ${
                      tableRowOpen[result.uid] ? 'is-open' : ''
                    } ${index % 2 === 0 ? '' : 'row--is-even'} ${
                      index === list.length - 1 ? 'row--is-last' : ''
                    }`}
                  >
                    <td data-label="Title">
                      <div class="search-table__title-wrapper">
                        <ResultIcon result={result} />
                        <button
                          className={`search-table__toggle-link ${
                            tableRowOpen[result.uid] ? 'is-open' : ''
                          }`}
                          onClick={e => {
                            toggleOpen(result.uid, e);
                          }}
                        >
                          <svg
                            class="svg-chevron-down"
                            aria-hidden="true"
                            xmlns="http://www.w3.org/2000/svg"
                            width="14"
                            height="14"
                            viewBox="0 0 14 14"
                          >
                            <path
                              fill="currentColor"
                              d="M 7,8.167306 12.444903,2.722403 14,4.2775 l -7,7 -7,-7 1.5550972,-1.555097 z"
                            />
                          </svg>
                          <span className="sr-only">Open row</span>
                        </button>
                        {result.title ? <p>{result.title}</p> : ''}
                      </div>
                    </td>
                    <td data-label="Date">{result.date}</td>
                    <td data-label="Open for">{result.openFor}</td>
                    <td data-label="Topic">{result.topic}</td>
                  </tr>
                  <tr
                    className={`search-table__additional-row ${
                      tableRowOpen[result.uid] ? 'is-open' : ''
                    } ${index % 2 === 0 ? '' : 'row--is-even'}`}
                  >
                    <td colspan="1">
                      {result.description ? (
                        <p className="search-table__paragraph">
                          <strong>
                            <span>Teaser</span>
                          </strong>
                          <br />
                          {result.description}
                        </p>
                      ) : (
                        ''
                      )}
                      {result.descriptionTwo ? (
                        <p className="search-table__paragraph">
                          <strong>
                            <span>Target Audience</span>
                          </strong>
                          <br />
                          {result.descriptionTwo}
                        </p>
                      ) : (
                        ''
                      )}
                      {result.descriptionThree ? (
                        <p className="search-table__paragraph">
                          <strong>
                            <span>Benefits and Learnings</span>
                          </strong>
                          <br />
                          {result.descriptionThree}
                        </p>
                      ) : (
                        ''
                      )}
                    </td>
                    <td colspan="3">
                      <ul className="search-table__list">
                        {result.time ? (
                          <li className="search-table__list-item">
                            <svg
                              class="svg-time"
                              width="20px"
                              height="20px"
                              aria-hidden="true"
                              viewBox="0 0 20 20"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                fill="currentColor"
                                d="M10,20 C4.477,20 0,15.523 0,10 C0,4.477 4.477,0 10,0 C15.523,0 20,4.477 20,10 C20,15.523 15.523,20 10,20 Z M10,18 C14.418278,18 18,14.418278 18,10 C18,5.581722 14.418278,2 10,2 C5.581722,2 2,5.581722 2,10 C2,14.418278 5.581722,18 10,18 Z M11,10 L15,10 L15,12 L9,12 L9,5 L11,5 L11,10 Z"
                              />
                            </svg>
                            <span>
                              Time:&nbsp;
                              {result.time}
                            </span>
                          </li>
                        ) : (
                          ''
                        )}

                        {result.partner ? (
                          <li className="search-table__list-item">
                            <svg
                              width="20"
                              height="20"
                              class="svg-rings"
                              xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 20 20"
                              aria-hidden="true"
                            >
                              <path
                                fill="currentColor"
                                d="M681 177c-31.333 0-61.167 4-89.5 12s-54.833 19-79.5 33c-24.667-14-51.5-25-80.5-33S373 177 343 177c-48 0-92.667 8.667-134 26-42 18-78.5 42.167-109.5 72.5S44.333 341.333 27 382C9 422.667 0 466 0 512s9 89.333 27 130c17.333 40.667 41.5 76.167 72.5 106.5S167 803 209 821c41.333 17.333 86 26 134 26 31.333 0 61.167-4 89.5-12s54.833-19 79.5-33c24.667 14 51.5 25 80.5 33s58.5 12 88.5 12c47.333 0 91.667-8.667 133-26 41.333-18 77.667-42.167 109-72.5s56-65.833 74-106.5 27-84 27-130-9-89.333-27-130c-17.333-40.667-41.5-76.167-72.5-106.5S857 221 815 203c-41.333-17.333-86-26-134-26Zm-81 335c0 37.333-8 72.167-24 104.5s-37.333 59.833-64 82.5c-26.667-22.667-48-50.167-64-82.5s-24-67.167-24-104.5 8-72.167 24-104.5 37.333-59.833 64-82.5c26.667 22.667 48 50.167 64 82.5s24 67.167 24 104.5Zm-515 0c0-35.333 6.667-68.333 20-99 14-31.333 32.667-58.5 56-81.5s50.667-40.833 82-53.5c31.333-13.333 64.667-20 100-20 17.333 0 34.167 1.5 50.5 4.5s32.167 7.167 47.5 12.5c-30 30-53.833 65.333-71.5 106S343 464 343 508c0 44.667 8.833 87.167 26.5 127.5S411 711.333 441 742c-15.333 4.667-31.167 8.667-47.5 12s-33.167 5-50.5 5c-36.667 2-70.667-3.333-102-16-31.333-12-58.5-29.333-81.5-52s-41.167-49.333-54.5-80c-13.333-30.667-20-63.667-20-99Zm596 254c-17.333 0-34.167-1.5-50.5-4.5s-32.167-7.167-47.5-12.5c30-30 53.833-65.333 71.5-106S681 560 681 516c0-44.667-8.833-87.167-26.5-127.5S613 312.667 583 282c15.333-4.667 31.167-8.667 47.5-12s33.167-5 50.5-5c35.333 0 68.667 6.667 100 20s58.667 31.333 82 54 42 49.667 56 81c13.333 30.667 20 63.667 20 99 0 33.333-6.667 65-20 95s-31.5 56.333-54.5 79-50.167 40.333-81.5 53c-31.333 13.333-65.333 20-102 20Z"
                                transform="matrix(.0192 0 0 .0192 .16 .025)"
                              />
                            </svg>
                            <span>
                              Organizers & Cooperation Partners:&nbsp;
                              <br />
                              {result.partner}
                            </span>
                          </li>
                        ) : (
                          ''
                        )}
                        {result.level ? (
                          <li className="search-table__list-item">
                            <svg
                              width="20"
                              height="20"
                              class="svg-volume"
                              xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 20 20"
                              aria-hidden="true"
                            >
                              <path
                                fill="currentColor"
                                d="M1000 379H843c-6 0-11.5 2.667-16.5 8s-7.5 11-7.5 17v578c0 6 2.5 11.5 7.5 16.5s10.5 7.5 16.5 7.5h163c6 0 11.5-2.5 16.5-7.5s7.5-10.5 7.5-16.5V404c-2.67-9.333-6.17-15.833-10.5-19.5s-10.83-5.5-19.5-5.5Zm-18 579H867V422h115v536ZM735 518H572c-6 0-11.5 2.5-16.5 7.5S548 536 548 542v440c0 6 2.5 11.5 7.5 16.5s10.5 7.5 16.5 7.5h163c6 0 11.5-2.5 16.5-7.5S759 988 759 982V542c-3.333-6-6.667-11.5-10-16.5s-8-7.5-14-7.5Zm-24 440H596V566h115v392ZM464 657H301c-6 0-11.5 2.5-16.5 7.5S277 675 277 681v295c0 6 2.5 11.5 7.5 16.5s10.5 7.5 16.5 7.5h163c6 0 11.5-2.5 16.5-7.5S488 982 488 976V681c0-6-2.5-11.5-7.5-16.5S470 657 464 657Zm-24 301H325V705h115v253ZM193 801H30c-6 0-11.5 2.5-16.5 7.5S6 819 6 825v157c0 6 2.5 11.5 7.5 16.5S24 1006 30 1006h163c6 0 11.5-2.5 16.5-7.5S217 988 217 982V825c0-8.667-2.5-14.833-7.5-18.5S199 801 193 801Zm-24 157H54V843h115v115Z"
                                transform="matrix(.01929 0 0 .01929 -.054 -3.719)"
                              />
                            </svg>
                            <span>
                              Level:&nbsp;
                              {result.level}
                            </span>
                          </li>
                        ) : (
                          ''
                        )}
                        {result.venue ? (
                          <li className="search-table__list-item">
                            <svg
                              class="svg-map"
                              width="18px"
                              height="22px"
                              aria-hidden="true"
                              viewBox="0 0 18 22"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                fill="currentColor"
                                d="M9,18.8999221 L13.95,13.9499221 C16.6834648,11.2161783 16.6833141,6.78415329 13.9496633,4.05059549 C11.2160125,1.31703769 6.7839875,1.31703769 4.05033671,4.05059549 C1.31668593,6.78415329 1.31653518,11.2161783 4.05,13.9499221 L9,18.8999221 Z M9,21.7279221 L2.636,15.3639221 C-0.878686958,11.8491921 -0.878663695,6.15072729 2.63605196,2.63602598 C6.15076761,-0.878675327 11.8492324,-0.878675327 15.363948,2.63602598 C18.8786637,6.15072729 18.878687,11.8491921 15.364,15.3639221 L9,21.7279221 L9,21.7279221 Z M9,10.9999221 C10.1045695,10.9999221 11,10.1044916 11,8.99992206 C11,7.89535256 10.1045695,6.99992206 9,6.99992206 C7.8954305,6.99992206 7,7.89535256 7,8.99992206 C7,10.1044916 7.8954305,10.9999221 9,10.9999221 Z M9,12.9999221 C6.790861,12.9999221 5,11.2090611 5,8.99992206 C5,6.79078306 6.790861,4.99992206 9,4.99992206 C11.209139,4.99992206 13,6.79078306 13,8.99992206 C13,11.2090611 11.209139,12.9999221 9,12.9999221 Z"
                              />
                            </svg>
                            <span>
                              Venue:&nbsp;
                              {result.venue} <br />
                              {result.locationLink ? (
                                <>
                                  <a
                                    href={result.locationLink}
                                    target="_blank"
                                    rel="noreferrer"
                                    className="link"
                                  >
                                    {result.locationLink}
                                  </a>
                                  <br />
                                </>
                              ) : (
                                ''
                              )}{' '}
                              {result.locationName ? (
                                <span>{result.locationName}</span>
                              ) : (
                                ''
                              )}
                              {result.locationStreet ? (
                                <span>{result.locationStreet}</span>
                              ) : (
                                ''
                              )}
                              {result.locationCity ? (
                                <span>{result.locationCity}</span>
                              ) : (
                                ''
                              )}
                              {result.locationPlace ? (
                                <span>{result.locationPlace}</span>
                              ) : (
                                ''
                              )}
                            </span>
                          </li>
                        ) : (
                          ''
                        )}
                        {result.speaker ? (
                          <li className="search-table__list-item">
                            <svg
                              width="20"
                              height="20"
                              xmlns="http://www.w3.org/2000/svg"
                              class="svg-speaker"
                              style="fill-rule:evenodd;clip-rule:evenodd;stroke-linecap:round;stroke-linejoin:round"
                              viewBox="0 0 20 20"
                              aria-hidden="true"
                            >
                              <path
                                fill="currentColor"
                                d="M6.857 11.429h4.572l7.619-7.619v24.38l-7.619-7.619H6.857a1.53 1.53 0 0 1-1.524-1.523v-6.096a1.53 1.53 0 0 1 1.524-1.523m15.238 12.19c2.032-1.524 3.048-4.063 3.048-7.619s-1.016-6.095-3.048-7.619m0 4.571v6.096"
                                style="fill:none;fill-rule:nonzero;stroke:#000;stroke-width:1.98px"
                                transform="matrix(.75638 0 0 .75638 -1.793 -2.064)"
                              />
                            </svg>
                            Speaker(s)/Host(s):&nbsp;
                            {result.speaker}
                          </li>
                        ) : (
                          ''
                        )}
                        {result.participants ? (
                          <li className="search-table__list-item">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="32"
                              height="32"
                              viewBox="0 0 24 24"
                              class="svg-persons"
                              aria-hidden="true"
                            >
                              <g
                                fill="none"
                                stroke="currentColor"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="2"
                              >
                                <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                                <circle cx="9" cy="7" r="4" />
                                <path d="M22 21v-2a4 4 0 0 0-3-3.87m-3-12a4 4 0 0 1 0 7.75" />
                              </g>
                            </svg>
                            <span>
                              Number of Participants:&nbsp;
                              {result.participants}
                            </span>
                          </li>
                        ) : (
                          ''
                        )}
                        {result.contact ? (
                          <li className="search-table__list-item">
                            <svg
                              class="svg-mail"
                              aria-hidden="true"
                              xmlns="http://www.w3.org/2000/svg"
                              width="20"
                              height="18"
                              viewBox="0 0 20 18"
                            >
                              <path
                                fill="currentColor"
                                transform="translate(-2.000000, -3.000000)"
                                d="M3,3 L21,3 C21.5522847,3 22,3.44771525 22,4 L22,20 C22,20.5522847 21.5522847,21 21,21 L3,21 C2.44771525,21 2,20.5522847 2,20 L2,4 C2,3.44771525 2.44771525,3 3,3 Z M20,7.238 L12.072,14.338 L4,7.216 L4,19 L20,19 L20,7.238 Z M4.511,5 L12.061,11.662 L19.502,5 L4.511,5 Z"
                              />
                            </svg>
                            <span>
                              Contact:&nbsp;
                              {result.contact}
                            </span>
                          </li>
                        ) : (
                          ''
                        )}
                        {result.downloadLink ? (
                          <li className="search-table__list-item">
                            <a
                              href={result.downloadLink}
                              className="search-table__list-link btn btn--small"
                              target="_blank"
                              rel="noreferrer"
                            >
                              <span>Download</span>
                              <svg
                                class="svg-download"
                                aria-hidden="true"
                                xmlns="http://www.w3.org/2000/svg"
                                width="18"
                                height="19"
                                viewBox="0 0 18 19"
                              >
                                <path
                                  fill="currentColor"
                                  transform="translate(-3.000000, -2.000000)"
                                  d="M3,19 L21,19 L21,21 L3,21 L3,19 Z M13,13.172 L19.071,7.1 L20.485,8.514 L12,17 L3.515,8.515 L4.929,7.1 L11,13.17 L11,2 L13,2 L13,13.172 Z"
                                />
                              </svg>
                            </a>
                          </li>
                        ) : (
                          ''
                        )}
                        {result.webLink ? (
                          <p className="search-table__paragraph">
                            <a
                              href={result.webLink}
                              target="_blank"
                              rel="noreferrer"
                              className="btn btn--tertiary"
                            >
                              <span>Register now</span>
                            </a>
                          </p>
                        ) : (
                          ''
                        )}
                      </ul>
                    </td>
                  </tr>
                </>
              ))}
          </tbody>
        </table>

        <Pagination
          pagination={pagination}
          triggerLoadMore={handleLoadMoreClick}
          pluginNamespace={pluginNamespace}
        />
      </div>
    </Fragment>
  );
};

export default TeaserCourses;
